var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNereusBlur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 136,
    viewBox: "0 0 110 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1617_78858)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_1617_78858)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.2712 88.8675C77.9413 91.2007 74.1603 91.2007 71.8303 88.8675L59.2137 76.2333C56.8838 73.9001 53.1028 73.9001 50.7729 76.2333L18.2086 108.843C15.8833 111.172 15.8833 114.944 18.2086 117.272L33.6801 132.765C36.01 135.098 39.791 135.098 42.1209 132.765L54.7292 120.139C57.0591 117.806 60.8402 117.806 63.1701 120.139L75.7867 132.774C78.1166 135.107 81.8976 135.107 84.2276 132.774L96.8499 120.134C99.1798 117.801 102.961 117.801 105.291 120.134L117.897 132.758C120.227 135.092 124.008 135.092 126.338 132.758L158.902 100.148C161.228 97.8199 161.228 94.048 158.902 91.7195L143.431 76.2264C141.101 73.8932 137.32 73.8931 134.99 76.2263L122.368 88.8662C120.038 91.1994 116.257 91.1993 113.927 88.8661L101.32 76.2417C98.9903 73.9085 95.2093 73.9085 92.8793 76.2417L80.2712 88.8675Z",
    fill: "#CDFEB0",
    fillOpacity: 0.11,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.2712 88.8675C77.9413 91.2007 74.1603 91.2007 71.8303 88.8675L59.2137 76.2333C56.8838 73.9001 53.1028 73.9001 50.7729 76.2333L18.2086 108.843C15.8833 111.172 15.8833 114.944 18.2086 117.272L33.6801 132.765C36.01 135.098 39.791 135.098 42.1209 132.765L54.7292 120.139C57.0591 117.806 60.8402 117.806 63.1701 120.139L75.7867 132.774C78.1166 135.107 81.8976 135.107 84.2276 132.774L96.8499 120.134C99.1798 117.801 102.961 117.801 105.291 120.134L117.897 132.758C120.227 135.092 124.008 135.092 126.338 132.758L158.902 100.148C161.228 97.8199 161.228 94.048 158.902 91.7195L143.431 76.2264C141.101 73.8932 137.32 73.8931 134.99 76.2263L122.368 88.8662C120.038 91.1994 116.257 91.1993 113.927 88.8661L101.32 76.2417C98.9903 73.9085 95.2093 73.9085 92.8793 76.2417L80.2712 88.8675Z",
    fill: "url(#paint1_linear_1617_78858)",
    fillOpacity: 0.1,
    shapeRendering: "crispEdges"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_1617_78858",
    x: 10.2956,
    y: 68.3073,
    width: 156.52,
    height: 72.3855,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.08465
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1617_78858"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.514108,
    dy: -0.514108
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1617_78858",
    result: "effect2_dropShadow_1617_78858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1617_78858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1617_78858",
    x1: 118.476,
    y1: 92.8,
    x2: 87.254,
    y2: 142.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6FCA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1617_78858"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 136,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNereusBlur);
export default __webpack_public_path__ + "static/media/nereus-blur.d50bcff007adba8ba61b8ba8e2559c62.svg";
export { ForwardRef as ReactComponent };